// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Erectile dysfunction REFILL 09.17.26" (638e0246-f461-435c-975b-2a9465ab21d9). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiErectileDysfunctionRefillAnswerField } from './questions';

export const mdiErectileDysfunctionRefill: FormType<mdiErectileDysfunctionRefillAnswerField> =
  {
    name: 'Erectile dysfunction REFILL',
    validityLength: 25,
    questions: [
      'mdiErectileDysfunctionRefill_medicationWerePrescribedHelped',
      {
        key: 'mdiErectileDysfunctionRefill_anythingChangedMedicalHistory',
        next: {
          condition: {
            'mdiErectileDysfunctionRefill_anythingChangedMedicalHistory.yes':
              true
          },
          key: 'mdiErectileDysfunctionRefill_listNewChangesMedicalHistory',
          els: 'mdiErectileDysfunctionRefill_anythingElseYoudLikeTell'
        }
      },
      'mdiErectileDysfunctionRefill_listNewChangesMedicalHistory',
      {
        key: 'mdiErectileDysfunctionRefill_anythingElseYoudLikeTell',
        next: {
          switch: [
            {
              condition: {
                'mdiErectileDysfunctionRefill_anythingElseYoudLikeTell.yes':
                  true
              },
              key: 'mdiErectileDysfunctionRefill_likeDiscuss'
            },
            {
              condition: {
                'mdiErectileDysfunctionRefill_likeDiscuss.question_for_support':
                  true
              },
              key: 'mdiErectileDysfunctionRefill_makeSureContactSupportDirectly'
            },
            {
              condition: {
                'mdiErectileDysfunctionRefill_likeDiscuss.billing_question':
                  true
              },
              key: 'mdiErectileDysfunctionRefill_makeSureContactSupportDirectly'
            },
            {
              condition: {
                'mdiErectileDysfunctionRefill_likeDiscuss.shipping_question':
                  true
              },
              key: 'mdiErectileDysfunctionRefill_makeSureContactSupportDirectly'
            }
          ],
          els: 'mdiErectileDysfunctionRefill_importantClickAttachedLinkReview'
        }
      },
      {
        key: 'mdiErectileDysfunctionRefill_likeDiscuss',
        next: {
          switch: [
            {
              condition: {
                'mdiErectileDysfunctionRefill_likeDiscuss.question_for_support':
                  true
              },
              key: 'mdiErectileDysfunctionRefill_makeSureContactSupportDirectly'
            },
            {
              condition: {
                'mdiErectileDysfunctionRefill_likeDiscuss.billing_question':
                  true
              },
              key: 'mdiErectileDysfunctionRefill_makeSureContactSupportDirectly'
            },
            {
              condition: {
                'mdiErectileDysfunctionRefill_likeDiscuss.shipping_question':
                  true
              },
              key: 'mdiErectileDysfunctionRefill_makeSureContactSupportDirectly'
            }
          ],
          els: 'mdiErectileDysfunctionRefill_importantClickAttachedLinkReview'
        }
      },
      'mdiErectileDysfunctionRefill_makeSureContactSupportDirectly',
      {
        key: 'mdiErectileDysfunctionRefill_importantClickAttachedLinkReview',
        next: {
          condition: {
            'mdiErectileDysfunctionRefill_likeDiscuss.question_for_doctor': true
          },
          key: 'mdiErectileDysfunctionRefill_tellDoctorAnythingYoudLike',
          els: 'mdiErectileDysfunctionRefill_complete'
        }
      },
      'mdiErectileDysfunctionRefill_tellDoctorAnythingYoudLike',
      'mdiErectileDysfunctionRefill_complete'
    ]
  };
